module.exports = __webpack_public_path__ + "static/media/02_quizz.6853aca2.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/StickyPhone/medias/02_quizz.mp4
// module id = 196
// module chunks = 0